import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-scores-card',
  templateUrl: './helpbutton-reports-scores-card.component.html',
  styleUrls: ['./helpbutton-reports-scores-card.component.scss']
})
export class HelpbuttonReportsScoresCardComponent implements OnInit {

  @Input() value1;
  @Input() value2;
  @Input() value3;

  constructor() { }

  ngOnInit() {
  }

}
